import { buttonVariants } from '@e2n/ui';
import { CreateAbschnitt } from '@/domain/mitarbeiter/features/rotationsplan/features/CreateAbschnitt/CreateAbschnitt';
import { Abschnitt } from '@/domain/mitarbeiter/features/rotationsplan/features/Details/Abschnitt';
import { Header } from '@/domain/mitarbeiter/features/rotationsplan/features/Details/Header';
import { useRotationsplanById } from '@/domain/mitarbeiter/features/rotationsplan/hooks/useRotationsplanById/useRotationsplanById';
import { useStandortContext } from '@/features/standortContext/StandortContext';
import { cn } from '@/lib/utils';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from 'react-i18next';
import { Link, useParams } from 'react-router-dom';
import {
  ActionDrawer,
  ActionDropdownMenu,
} from '@/domain/mitarbeiter/features/rotationsplan/features/Details/ActionMenu';

export function Details() {
  const { id } = useParams();
  const { t } = useTranslation();
  const { standorte } = useStandortContext();
  const standortIds = standorte.map((s) => s.id);
  const { rotationsplan } = useRotationsplanById(standortIds, id);

  return (
    <div className="flex flex-col gap-5">
      <div className="flex justify-between items-start">
        <div className="flex gap-2 items-center">
          <Link
            to={`/mitarbeiter/rotationsplaene/uebersicht`}
            className={cn(buttonVariants({ variant: 'ghost', size: 'icon' }))}>
            <FontAwesomeIcon
              className="text-primary-blue-600"
              icon={faArrowLeft}
            />
          </Link>
          <div className="font-semibold text-sm md:text-base">
            {t('domain.mitarbeiter.rotationsplan.tabs.rotationsplaene')}
          </div>
        </div>
        {rotationsplan && (
          <>
            <div className="hidden sm:flex">
              <ActionDropdownMenu rotationsplan={rotationsplan} />
            </div>
            <div className="flex sm:hidden">
              <ActionDrawer rotationsplan={rotationsplan} />
            </div>
          </>
        )}
      </div>

      {!rotationsplan ? (
        <div className="text-neutrals-700">
          {t('domain.mitarbeiter.rotationsplan.rotationsplaene.notFound')}
        </div>
      ) : (
        <>
          <Header rotationsplan={rotationsplan} />
          {rotationsplan.abschnitte.map((abschnitt) => (
            <Abschnitt
              key={abschnitt.id}
              abschnitt={abschnitt}
              rotationsplan={rotationsplan}
            />
          ))}
          <CreateAbschnitt rotationsplan={rotationsplan} />
        </>
      )}
    </div>
  );
}
